export default __webpack_public_path__ + "static/media/3074.cf7f1318.jpg";